module.exports = __webpack_public_path__ + "img/多益攻略.0ffd105e.png";